import { Coach } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const coachesApi = createApi({
  reducerPath: 'coachesApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCoaches: builder.query<Coach[], undefined>({
      query: () => 'coaches/browse',
      keepUnusedDataFor: 60 * 60 * 24, // Cache for 24 hours
    }),
    getCoachById: builder.query<Coach, number>({
      query: (id) => `coaches/browse/${id}`,
      keepUnusedDataFor: 60 * 60 * 24, // Cache for 24 hours
    }),
  }),
});

export const { useGetCoachesQuery, useGetCoachByIdQuery } = coachesApi;
